import _objectWithoutProperties from "/home/runner/work/primer.style/primer.style/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["variant", "size", "sx", "icon"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { forwardRef } from 'react';
import { merge } from '../sx';
import { useTheme } from '../ThemeProvider';
import Box from '../Box';
import { StyledButton } from './types';
import { getBaseStyles, getSizeStyles, getVariantStyles } from './styles';
var IconButton = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'default' : _props$variant,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$sx = props.sx,
      sxProp = _props$sx === void 0 ? {} : _props$sx,
      Icon = props.icon,
      rest = _objectWithoutProperties(props, _excluded);

  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  var sxStyles = merge.all([getBaseStyles(theme), getSizeStyles(size, variant, true), getVariantStyles(variant, theme), sxProp]);
  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    sx: sxStyles
  }, rest, {
    ref: forwardedRef
  }), /*#__PURE__*/React.createElement(Box, {
    as: "span",
    sx: {
      display: 'inline-block'
    }
  }, /*#__PURE__*/React.createElement(Icon, null)));
});
export { IconButton };